
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./HPGasInlet.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";





 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function HPGasInlet() {

        useEffect(() => {
  
    trackPageVisit("HPGasInlet");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);
    
    
    
const { compressorE, compressorF, CompressorTrendFaceplate } = useContext(CompressorContext);

const compressor = compressorE; // or E depending on page
    

    const [open, setOpen, ] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);






          const historianData = useMemo(() => {
            return {
              time: compressor.history?.time || [],
              PT_suction: compressor.history?.PT_suction || [],
              PT_discharge: compressor.history?.PT_discharge || [],
              TT_suction: compressor.history?.TT_suction || [],
              TT_discharge: compressor.history?.TT_discharge || [],
              FIC_suction: compressor.history?.FIC_suction || [],
              FIC_discharge: compressor.history?.FIC_discharge || [],
              speed: compressor.history?.speed || []
            };
          }, [compressor.history]);

    

    

  const DEFAULT_VALVES = {
  FCV_2001A: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_2001A: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_2002: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("HPGasInlet_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2001A: { ...DEFAULT_VALVES.FCV_2001A, ...parsed.FCV_2001A },
      PCV_2001A: { ...DEFAULT_VALVES.PCV_2001A, ...parsed.PCV_2001A },
      PCV_2002: { ...DEFAULT_VALVES.PCV_2002, ...parsed.PCV_2002 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("HPGasInlet_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO LP COMPRESSOR =================

  const [FIC_18003B, setFIC_18003B] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_18003B")) || 0;
            setFIC_18003B(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_18003A, setFIC_18003A] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_18003A")) || 0;
            setFIC_18003A(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_18008B, setPT_18008B] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_18008B")) || 0;
            setPT_18008B(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_18008B, setTT_18008B] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_18008B")) || 0;
            setTT_18008B(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_18003, setFIC_18003] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_18003")) || 0;
            setFIC_18003(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_18008A, setPT_18008A] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_18008A")) || 0;
            setPT_18008A(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_18008A, setTT_18008A] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_18008A")) || 0;
            setTT_18008A(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_12004, setFIC_12004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_12004")) || 0;
            setFIC_12004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_12004, setPT_12004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_12004")) || 0;
            setPT_12004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_12004, setTT_12004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_12004")) || 0;
            setTT_12004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_12003, setTT_12003] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_12003")) || 0;
            setTT_12003(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2703, setFIC_2703] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2703")) || 0;
            setFIC_2703(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2702, setPT_2702] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2702")) || 0;
            setPT_2702(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


  const [FIC_2004b, setFIC_2004b] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2004b")) || 0;
            setFIC_2004b(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2004b, setPT_2004b] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2004b")) || 0;
            setPT_2004b(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_2004b, setTT_2004b] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_2004b")) || 0;
            setTT_2004b(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



  /* ================= VALVE STATUS ================= */

  const isXV2001Open = valves?.XV_2001 === false;
  const isXV2002Open = valves?.XV_2002 === false;
  const isXV2003Open = valves?.XV_2003 === false;
  const isXV2004Open = valves?.XV_2004 === false;
  const isXV2005Open = valves?.XV_2005 === false;
  const isXV2006Open = valves?.XV_2006 === false;


  const FIC_2010 = FIC_12004;
  const PT_2010 = PT_12004;
  const FIC_2011 = FIC_2703;
  const PT_2011 = PT_2702;
 

  const FIC_20011 = FIC_18003A + FIC_18003B;
  const validPTs = [PT_18008A, PT_18008B].filter(
        (v) => v != null && !isNaN(v) && Number(v) >= 1
      );

      const PT_2001 =
        validPTs.length > 0
          ? validPTs.reduce((a, b) => a + b, 0) / validPTs.length
          : 0;

  const FIC_2001 = isXV2001Open ? FIC_2010 + FIC_20011 + FIC_2011 : 0;

  const FIC_2002 = FIC_2001 * 0.89;

  const validTTs = [
  TT_12003,
  TT_12004,
  TT_18008A,
  TT_18008B
].filter(
  (v) => v != null && !isNaN(v) && Number(v) >= 1
);

const TT_2002 = isXV2001Open
  ? (
      validTTs.length > 0
        ? validTTs.reduce((a, b) => a + b, 0) / validTTs.length
        : 21
    )
  : 21;


  const validPT2002 = [
  PT_2010,
  PT_2001,
  PT_2011
].filter(
  (v) => v != null && !isNaN(v) && Number(v) >= 1
);

const PT_2002 = isXV2001Open
  ? (
      validPT2002.length > 0
        ? 0.9999 *
          (
            validPT2002.reduce((a, b) => a + b, 0) /
            validPT2002.length
          )
        : 0.03
    )
  : 0.03;

  const FIC_2003 = FIC_2002 * (valveData?.PCV_2001A?.opening || 0)/100;

  const FIC_20021 = FIC_2002 - FIC_2003;


// ================= MAIN INLET FLOW =================

const inletFlow = FIC_20021 || 0;

// ================= FLOW SPLIT =================

let FIC_2006 = 0;
let FIC_2007 = 0;

// BOTH OPEN → 50/50 SPLIT
if (isXV2003Open && isXV2004Open) {

  FIC_2006 = inletFlow * 0.5;
  FIC_2007 = inletFlow * 0.5;
}

// ONLY XV_2003 OPEN
else if (isXV2003Open) {

  FIC_2006 = inletFlow;
  FIC_2007 = 0;
}

// ONLY XV_2004 OPEN
else if (isXV2004Open) {

  FIC_2006 = 0;
  FIC_2007 = inletFlow;
}

// BOTH CLOSED
else {

  FIC_2006 = 0;
  FIC_2007 = 0;
}

const PIC_2001 = isXV2003Open ? PT_2002 * (valveData?.PCV_2002?.opening || 0)/100 : 0.03;
const PIC_2002 = isXV2004Open ? PT_2002 * (valveData?.PCV_2003?.opening || 0)/100 : 0.03;


const FIC_2005 = isXV2002Open ? 15.4 * (valveData?.FCV_2001A?.opening || 0)/100 : 0;

const FIC_2008 = FIC_2005*1.05;
const FIC_2009 = FIC_2005*1.053;



// ======================================================
// SINGLE STAGE COMPRESSOR SIMULATION
// ======================================================

const compressorResults =
  simulateSingleStageCompressor({

    suctionPressure: PIC_2001,
    suctionTemperature: TT_2002,
    suctionFlow: FIC_2006,

    isRunning: compressor.running,

    compressorEfficiency: 0.82,

    compressionRatio: 3.1
  });


useEffect(() => {

  const interval = setInterval(() => {

    updateCompressor(compressor, {
      suctionPressure: PIC_2001,
      suctionTemperature: TT_2002,
      suctionFlow: FIC_2006
    });

    forceRender(v => v + 1);

  }, 200); // DCS-like scan time

  return () => clearInterval(interval);

}, [PIC_2001, TT_2002, FIC_2006]);

// ======================================================
// DISCHARGE VALUES
// ======================================================

const FIC_2004a =
  compressorResults.dischargeFlow*1.22;

const PT_2004a =
  compressorResults.dischargePressure*25.6; 

const TT_2004a =
  compressorResults.dischargeTemperature;




const FIC_2004 = isXV2005Open ? FIC_2004a : 0;
const PT_2004 = isXV2005Open ? PT_2004a : 0;
const TT_2004 = isXV2005Open ? TT_2004a : 0;


  useEffect(() => {
  localStorage.setItem("PIC_2002", PIC_2002);
}, [PIC_2002]);

  useEffect(() => {
  localStorage.setItem("TT_2002", TT_2002);
}, [TT_2002]);

  useEffect(() => {
  localStorage.setItem("FIC_2007", FIC_2007);
}, [FIC_2007]);

useEffect(() => {
  localStorage.setItem("FIC_2003", FIC_2003);
}, [FIC_2003]);




  useEffect(() => {
  localStorage.setItem("FIC_2004", FIC_2004);
}, [FIC_2004]);

  useEffect(() => {
  localStorage.setItem("PT_2004", PT_2004);
}, [PT_2004]);

  useEffect(() => {
  localStorage.setItem("TT_2004", TT_2004);
}, [TT_2004]);












  return (
    <div className="HPGasInlet-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "230px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 200px"
      }}>
        HP INLET SEPARATOR AND HP COMPRESSORS
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-2001"
        tag="XV_2001"
        x={165}
        y={238}
        isClosed={valves.XV_2001}
        toggle={toggleValve}
      />

      {/* XV-2002 */}
      <Valve
        className="XV-2002"
        tag="XV_2002"
        x={393}
        y={567}
        isClosed={valves.XV_2002}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-2003 */}
      <Valve
        className="XV-2003"
        tag="XV_2003"
        x={675}
        y={650}
        isClosed={valves.XV_2003}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-2004 */}
      <Valve
        className="XV-2004"
        tag="XV_2004"
        x={1041}
        y={650}
        isClosed={valves.XV_2004}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-2005 */}
      <Valve
        className="XV-2005"
        tag="XV_2005"
        x={673}
        y={246}
        isClosed={valves.XV_2005}
        toggle={toggleValve}
        r={270}
      />

      
      {/* XV-2006 */}
      <Valve
        className="XV-2006"
        tag="XV_2006"
        x={1037}
        y={246}
        isClosed={valves.XV_2006}
        toggle={toggleValve}
        r={270}

      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2001A */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2001A"
          style={{ position: "absolute", left: 1084, top: 751}}  onClick={() => openPanel("FCV_2001A")}>
          
          <defs>
            <linearGradient id="metal_2001A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2001A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2001A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* PCV-2001A */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="PCV-2001A"
          style={{ position: "absolute", left: 435, top: 210, }}  onClick={() => openPanel("PCV_2001A")}>
          
          <defs>
            <linearGradient id="metal_2001A">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2001A)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2001A)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* PCV-2002 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="PCV-2002"
          style={{ position: "absolute", left: 650, top: 570, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_2002")}>
          
          <defs>
            <linearGradient id="metal_2002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2002)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* PCV-2003 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="PCV-2003"
          style={{ position: "absolute", left: 1015, top: 570, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_20023")}>
          
          <defs>
            <linearGradient id="metal_2003">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2003)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2003)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          
          <div
              onClick={() => setOpen(true)}
              style={{
                position: "absolute",
                left: 687,
                top: 410,
                width: 150,
                height: 30,

                background:

                  compressor.status === "RUNNING"
                    ? "#00aa00"

                  : compressor.status === "STARTING"
                    ? "#d4aa00"

                  : compressor.status === "SHUTTING DOWN"
                    ? "#ff8800"

                  : compressor.status === "READY"
                    ? "#0099ff"

                  : compressor.status === "TRIPPED"
                    ? "#ff3300"

                  : "#666666",

                color: "white",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                border: "2px solid cyan",

                cursor: "pointer",

                fontWeight: "bold",

                borderRadius: "8px",

                boxShadow:
                  compressor.running
                    ? "0 0 15px lime"
                    : "0 0 10px red",

                transition: "0.3s"
              }}
            >
              {compressor.status}
            </div>


          {open && (
            <SingleStageCompressorFaceplate
              input={{
                PIC_2001,
                TT_2002,
                FIC_2006,
                FIC_2004a,
                PT_2004a,
                TT_2004a,
              }}
              compressor={compressor}
              close={() => setOpen(false)}
              openTrend={() => setShowTrend(true)}
            />
          )}



           <div
            onClick={() =>
              alert(
                "This Compressor (C-104) will be developed fully and launched later in the Future."
              )
            }
            style={{
              position: "absolute",
              left: 1067,
              top: 410,
              width: 150,
              height: 30,

              background:
                compressor.status === "RUNNING"
                  ? "#00aa00"

                : compressor.status === "STARTING"
                  ? "#d4aa00"

                : compressor.status === "SHUTTING DOWN"
                  ? "#ff8800"

                : compressor.status === "READY"
                  ? "#0099ff"

                : compressor.status === "TRIPPED"
                  ? "#ff3300"

                : "#666666",

              color: "white",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              border: "2px solid cyan",

              cursor: "pointer",

              fontWeight: "bold",

              borderRadius: "8px",

              boxShadow:
                compressor.running
                  ? "0 0 15px lime"
                  : "0 0 10px red",

              transition: "0.3s"
            }}
          >
            {compressor.status}
          </div>




          




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2001A?.opening || 0)}
        x={1107}
        y={794}
      />
      <ValveOutput
        value={Number(valveData?.PCV_2001A?.opening || 0)}
        x={456}
        y={255}
      />
      <ValveOutput
        value={Number(valveData?.PCV_2002?.opening || 0)}
        x={707}
        y={585}
      />
      <ValveOutput
        value={Number(valveData?.PCV_2003?.opening || 0)}
        x={1086}
        y={585}
      />



          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      
      
      <Transmitter
        tag="FIC-2010"
        value={[FIC_2010]}
        x={74}
        y={112}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF 1ST STAGE SEPARATOR DUAL AIR COOLERS"
      />

      <Transmitter
        tag="PT-2010"
        value={[PT_2010]}
        x={77}
        y={175}
        unit="MPa"
        max={10}
        HH={9}
        H={8}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE DISCHARGE OF 1ST STAGE SEPARATOR DUAL AIR COOLERS"
      />

      <Transmitter
        tag="FIC-20011"
        value={[FIC_20011]}
        x={74}
        y={292}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF MP COMPRESSORS A/B"
      />

      <Transmitter
        tag="PT-2001"
        value={[PT_2001]}
        x={77}
        y={214}
        unit="MPa"
        max={10}
        HH={9}
        H={8}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE DISCHARGE OF MP COMPRESSORS A/B"
      />

      <Transmitter
        tag="FIC-2011"
        value={[FIC_2011]}
        x={74}
        y={332}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE OVERHEAD OF SLUDGE CATCHER SUCTION DRUM"
      />

      <Transmitter
        tag="PT-2011"
        value={[PT_2011]}
        x={153}
        y={332}
        unit="MPa"
        max={10}
        HH={9}
        H={8}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE OVERHEAD OF SLUDGE CATCHER SUCTION DRUM"
      />

      <Transmitter
        tag="FIC-2001"
        value={[FIC_2001]}
        x={153}
        y={176}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS TO THE INLET OF HP INLET SEPARATOR"
      />

      <Transmitter
        tag="FIC-2002"
        value={[FIC_2002]}
        x={393}
        y={153}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE OVERHEAD OF HP INLET SEPARATOR"
      />

      <Transmitter
        tag="PT-2002"
        value={[PT_2002]}
        x={313}
        y={152}
        unit="MPa"
        max={10}
        HH={9}
        H={8}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE OVERHEAD OF HP INLET SEPARATOR"
      />

      <Transmitter
        tag="TT-2002"
        value={[TT_2002]}
        x={470}
        y={153}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE OVERHEAD OF HP INLET SEPARATOR"
      />

      <Transmitter
        tag="FIC-2003"
        value={[FIC_2003]}
        x={603}
        y={75}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE OVERHEAD OF HP INLET SEPARATOR TO FLARE HEADER"
      />

      <Transmitter
        tag="FIC-2006"
        value={[FIC_2006]}
        x={714}
        y={638}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE SUCTION OF HP COMPRESSOR C-103"
      />

      <Transmitter
        tag="FIC-2007"
        value={[FIC_2007]}
        x={1095}
        y={638}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE SUCTION OF HP COMPRESSOR C-104"
      />

      <Transmitter
        tag="PIC-2001"
        value={[PIC_2001]}
        x={576}
        y={480}
        unit="MPa"
        max={1}
        HH={0.5}
        H={0.25}
        L={0.10}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE SUCTION OF HP COMPRESSOR C-103"
      />

      <Transmitter
        tag="PIC-2002"
        value={[PIC_2002]}
        x={965}
        y={480}
        unit="MPa"
        max={1}
        HH={0.5}
        H={0.25}
        L={0.10}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE SUCTION OF HP COMPRESSOR C-104"
      />

      <Transmitter
        tag="FIC-2005"
        value={[FIC_2005]}
        x={614}
        y={752}
        unit="LPM"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CONDENSED FLUID FROM HP INLET SEPARATOR TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-2008"
        value={[FIC_2008]}
        x={917}
        y={752}
        unit="LPM"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CONDENSED FLUID FROM HP INLET SEPARATOR TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-2009"
        value={[FIC_2009]}
        x={1201}
        y={752}
        unit="LPM"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CONDENSED FLUID FROM HP INLET SEPARATOR TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-2004"
        value={[FIC_2004]}
        x={1041}
        y={126}
        unit="SCF/S"
        max={500}
        HH={490}
        H={485}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF COMPRESSED GAS AT THE DISCHARGE OF C-103 AND C-104"
      />

      <Transmitter
        tag="PT-2004"
        value={[PT_2004]}
        x={863}
        y={126}
        unit="MPa"
        max={10}
        HH={9}
        H={8}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF COMPRESSED GAS AT THE DISCHARGE OF C-103 AND C-104"
      />

      <Transmitter
        tag="TT-2004"
        value={[TT_2004]}
        x={970}
        y={126}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF COMPRESSED GAS AT THE DISCHARGE OF C-103 AND C-104"
      />





      <LevelTransmitterIndicator
      tag="LT_2001"
      totalLevel={100000}
      inflows={[FIC_2001 * 0.018]}
      outflows={[FIC_2005]}
      responseFactor={0.05}
      columnX={256}
      columnY={254}
      columnWidth={86}
      columnHeight={177}
      textX={359}
      textY={320}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />




          {showTrend && (
            <CompressorTrendFaceplate
              data={historianData}
              close={() => setShowTrend(false)}
            />
          )}

      
       

    </div>
  );
}


export default HPGasInlet;

